<template>
  <el-dialog
    :visible.sync="dialogVisible"
    custom-class="custom-dialog"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :append-to-body="true"
    width="80vw"
  >
    <div slot="title" class="title">
      <div class="title-name">项目概况</div>
      <div class="side-title"></div>
      <div class="handle-btn"></div>
    </div>
    <div class="edit-dialog-part">
      <el-row :gutter="16">
        <el-col :span="12">
          <div class="edit-dialog-item">
            <b>项目名称:</b>
            <el-input v-model="projectInEdit.项目名称" size="mini" style="width:300px"></el-input>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="edit-dialog-item">
            <b>部门:</b>
            <el-input v-model="projectInEdit.部门" size="mini" style="width:300px"></el-input>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="16">
        <el-col :span="12">
          <div class="edit-dialog-item">
            <b>优先级:</b>
            <el-rate v-model="projectInEdit.优先级" :colors="colors"></el-rate>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="edit-dialog-item">
            <b>办公地点:</b>
            <iconSelect
              v-model="projectInEdit['办公地']"
              class="field-value"
              placeholder="填写办公地点，可多选"
              :options="locations"
            >
              <i slot="icon" class="el-icon-s-grid" style="color: #409eff;" @click="toChooseCity"></i>
            </iconSelect>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="16">
        <!-- <el-col :span="12">
          <div class="edit-dialog-item">
            <b>年薪:</b>
            <div class="flex align-center salary-input">
              <el-input v-model="projectInEdit['年薪范围'][0]" style="width:100px" size="mini">
                <template slot="append"
                  >万</template
                >
              </el-input>
              --
              <el-input v-model="projectInEdit['年薪范围'][1]" style="width:100px" size="mini">
                <template slot="append"
                  >万</template
                >
              </el-input>
            </div>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="edit-dialog-item">
            <b>月薪:</b>
            <div class="flex align-center salary-input">
              <el-input v-model="projectInEdit['月薪范围'][0]" style="width:100px" size="mini">
                <template slot="append"
                  >万</template
                >
              </el-input>
              --
              <el-input v-model="projectInEdit['月薪范围'][1]" style="width:100px" size="mini">
                <template slot="append"
                  >万</template
                >
              </el-input>
            </div>
          </div>
        </el-col> -->
        <el-col :span="12">
          <div class="edit-dialog-item">
            <b>固薪:</b>
            <div class="flex align-center salary-input">
              <el-input v-model="projectInEdit.最低固薪" style="width:130px" size="mini">
                <template slot="append"
                  >万</template
                >
              </el-input>
              --
              <el-input v-model="projectInEdit.最高固薪" style="width:130px" size="mini">
                <template slot="append"
                  >万</template
                >
              </el-input>
            </div>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="edit-dialog-item">
            <b>全薪:</b>
            <div class="flex align-center salary-input">
              <el-input v-model="projectInEdit.最低全薪" style="width:130px" size="mini">
                <template slot="append"
                  >万</template
                >
              </el-input>
              --
              <el-input v-model="projectInEdit.最高全薪" style="width:130px" size="mini">
                <template slot="append"
                  >万</template
                >
              </el-input>
            </div>
          </div>
        </el-col>
        <el-col :span="20">
          <div class="edit-dialog-item">
            <b>岗位薪酬备注:</b>
            <el-input v-model="projectInEdit.岗位薪酬备注" size="mini">
            </el-input>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="16">
        <el-col :span="12">
          <div class="edit-dialog-item">
            <b>年龄要求:</b>
            <div class="flex align-center">
              <el-input v-model="projectInEdit['年龄要求'][0]" style="width:100px" size="mini">
                <template slot="append"
                  >岁</template
                >
              </el-input>
              --
              <el-input v-model="projectInEdit['年龄要求'][1]" style="width:100px" size="mini">
                <template slot="append"
                  >岁</template
                >
              </el-input>
            </div>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="edit-dialog-item">
            <b>工作年限:</b>
            <div class="flex align-center">
              <el-input v-model="projectInEdit['工作年限'][0]" style="width:100px" size="mini">
                <template slot="append"
                  >年</template
                >
              </el-input>
              --
              <el-input v-model="projectInEdit['工作年限'][1]" style="width:100px" size="mini">
                <template slot="append"
                  >年</template
                >
              </el-input>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row type="flex" align="center">
        <el-col :span="12">
          <div class="edit-dialog-item">
            <b>预计第一批人推荐时间:</b>
            <el-date-picker
              v-model="projectInEdit.indroduceTime"
              type="date"
              size="mini"
              value-format="timestamp"
              class="field-value"
              :picker-options="pickerOptions"
            />
          </div>
        </el-col>
      </el-row>
    </div>
    <div slot="footer">
      <el-row type="flex" align="center" justify="center">
        <el-button size="small" type="info" style="margin-right:20px" @click="cancelEdit">取消</el-button>
        <el-button size="small" type="primary" class="custom-primary-plain" @click="confirmEdit(true)">保存</el-button>
      </el-row>
    </div>
    <ChooseCity ref="ChooseCity"></ChooseCity>
  </el-dialog>
</template>
<script>
import iconSelect from '../NewCreateProject/iconSelect'
import ChooseCity from '../NewCreateProject/ChooseCity'
import { locations } from '../../constant/type'

export default {
  components: { iconSelect, ChooseCity },
  props: {
    project: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      locations,
      colors: ['#99A9BF', '#F7BA2A', '#FF9900'],
      dialogVisible: false,
      projectInEdit: {
        项目名称:'',
        优先级: 0,
        办公地: [],
        最低固薪: '',
        最高固薪: '',
        最低全薪: '',
        最高全薪: '',
        年龄要求: ['', ''],
        工作年限: ['', ''],
        indroduceTime: '',
      },
      pickerOptions: {},
    }
  },
  mounted() {
    this.setTimePicker()
  },
  methods: {
    open() {
      const projectInEdit = JSON.parse(
        JSON.stringify({
          项目名称:this.project.项目名称 || '',
          优先级: this.project.优先级 || 0,
          办公地: this.project.办公地 || [],
          最低固薪: this.project.最低固薪 || '',
          最高固薪: this.project.最高固薪 || '',
          最低全薪: this.project.最低全薪 || '',
          最高全薪: this.project.最高全薪 || '',
          年龄要求: this.project.年龄要求 || ['', ''],
          工作年限: this.project.工作年限 || ['', ''],
          indroduceTime: this.project.indroduceTime || Date.now(),
        }),
      )
      this.projectInEdit = projectInEdit
      this.dialogVisible = true
    },
    toChooseCity() {
      const param = {
        default: this.projectInEdit['办公地'],
        func: (val) => this.$set(this.projectInEdit, '办公地', val),
      }
      this.$refs.ChooseCity.open(param.default, param.func)
    },
    setTimePicker() {
      this.pickerOptions = {
        shortcuts: [
          {
            text: '一天推荐',
            onClick(picker) {
              picker.$emit('pick', new Date())
            },
          },
          {
            text: '三天推荐',
            onClick(picker) {
              const date = new Date()
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 3)
              picker.$emit('pick', date)
            },
          },
        ],
      }
    },
    cancelEdit() {
      this.projectInEdit = {
        项目名称:'',
        优先级: 0,
        办公地: [],
        年薪范围: ['', ''],
        月薪范围: ['', ''],
        年龄要求: ['', ''],
        工作年限: ['', ''],
        indroduceTime: '',
      }
      this.dialogVisible = false
    },
    async confirmEdit() {
      try {
        const res = await app.service('project').modify({
          id: this.project._id,
          param: this.projectInEdit,
        })
        await this.$emit('loadData')
        this.$message.success(`修改成功`)
      } catch (e) {
        this.$message.error(`修改失败:${e.message}`)
      }
      this.dialogVisible = false
    },
  },
}
</script>
<style scoped>
.edit-dialog-part {
  padding-bottom: 4px;
  margin-bottom: 16px;
  border-bottom: 1px solid rgb(234, 234, 234);
  font-size: 14px;
}
.edit-dialog-part:last-of-type {
  margin-bottom: -20px;
}
.edit-dialog-part .el-row {
}
.edit-dialog-tip {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}
.edit-dialog-tip i {
  font-size: 20px;
  margin-right: 10px;
}
.edit-dialog-item {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  position: relative;
}
.edit-dialog-item b {
  color: #999;
  font-weight: normal;
  min-width: 90px;
  display: inline-block;
}
.flex-wrap {
  flex-wrap: wrap;
}
.edit-dialog-title {
  margin-bottom: 16px;
  color: #999;
}
.edit-dialog-title b {
  font-size: 16px;
  color: #303133;
}
.edit-dialog-pre {
  font-size: 12px;
  line-height: 1.5;
  margin-bottom: 16px;
  width: 100%;
  margin-top: 0;
}
.edit-dialog-input-wrap {
  width: 100%;
  position: relative;
  margin-bottom: 16px;
}
.edit-dialog-single-p {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  width: 100%;
}
.edit-dialog-single-p b {
  color: #409eff;
  margin-right: 16px;
}
.flex {
  display: flex;
}
.align-center {
  align-items: center;
}
</style>
